import { render, staticRenderFns } from "./DashManagement.vue?vue&type=template&id=6a17efec&scoped=true&"
import script from "./DashManagement.vue?vue&type=script&lang=js&"
export * from "./DashManagement.vue?vue&type=script&lang=js&"
import style0 from "./DashManagement.vue?vue&type=style&index=0&id=6a17efec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a17efec",
  null
  
)

export default component.exports